import { render } from "./SpmiHome.vue?vue&type=template&id=077c18eb"
import script from "./SpmiHome.vue?vue&type=script&lang=js"
export * from "./SpmiHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__